export class ImageModel {
  public imageId: number;
  public imageContent: any;
  public imageType: string;
  public imageName: string;
}